/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_N2Inputs */

const en_formatter_ref_n2 = /** @type {(inputs: Formatter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exponent notation is expanded when the plain form is shorter.`)
};

const ko_formatter_ref_n2 = /** @type {(inputs: Formatter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평문 표기가 더 짧으면 지수 표기가 풀립니다.`)
};

const ja_formatter_ref_n2 = /** @type {(inputs: Formatter_Ref_N2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平文表記のほうが短い場合、指数表記が展開されます。`)
};

/**
* | output |
* | --- |
* | "Exponent notation is expanded when the plain form is shorter." |
*
* @param {Formatter_Ref_N2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_n2 = /** @type {((inputs?: Formatter_Ref_N2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_N2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_n2(inputs)
	if (locale === "ko") return ko_formatter_ref_n2(inputs)
	return ja_formatter_ref_n2(inputs)
});